import { createSelector } from 'reselect';

import getOrdering from './getOrdering';

export default createSelector([getOrdering], (ordering): number => {
  const { futureOrderingLimitGeneric } = ordering.config;
  return futureOrderingLimitGeneric;
});
